import type { InteractionInsight, PermissionState } from "./domain";
import { interactionInsights } from "./fixtures";

export type EvidencePrincipal = {
  organisationId: string;
  permissions: PermissionState[];
};
export type EvidenceView = Omit<
  InteractionInsight,
  "summary" | "importantMoments" | "sourceReference"
> & {
  summary: string;
  importantMoments: string[];
  sourceReference?: string | undefined;
};
export const demoPrincipal: EvidencePrincipal = {
  organisationId: interactionInsights[0]!.organisationId,
  permissions: ["granted", "redacted", "denied"],
};

export function queryEvidence(principal: EvidencePrincipal): EvidenceView[] {
  return interactionInsights
    .filter(
      (item) =>
        item.organisationId === principal.organisationId &&
        principal.permissions.includes(item.permissionState),
    )
    .map((item) => {
      if (item.permissionState === "denied")
        return {
          ...item,
          summary: "Source evidence is unavailable for this role.",
          importantMoments: [],
          sourceReference: undefined,
        };
      if (item.permissionState === "redacted")
        return {
          ...item,
          summary: item.summary.replace(
            /customer/gi,
            "customer [identity redacted]",
          ),
          importantMoments: item.importantMoments.map((x) =>
            x.replace(/customer/gi, "customer [identity redacted]"),
          ),
        };
      return item;
    });
}
